<template>
  <v-dialog
    v-model="getDeleteUser"
    @click:outside="_setActive(false)"
    :width="dialogStyle"
    id="delete-user-dialog"
  >
    <v-card style="overflow-x: hidden; color:white;" color="primary">
      <v-card-title style="height:120px;">
        <v-container color="secondary">
          <v-row class="d-flex flex-row justify-center">
            <h2 color="primary">Delete User</h2>
          </v-row>
        </v-container>
      </v-card-title>
      <div style="background-color:white; color:black;" class="pt-8">
        <div
          class="d-flex flex-column align-center mb-8"
          id="delete-user-confirmation"
        >
          <h3>Are you sure you want to delete</h3>
          <h3>{{ data.user_name }}?</h3>
        </div>
        <div class="d-flex justify-center pb-5">
          <v-btn
            large
            color="primary"
            style="width: 50%;"
            @click="clickHandler"
            id="delete-user-yes"
            >Yes Delete</v-btn
          >
        </div>
        <div class="d-flex justify-center pb-5">
          <v-btn
            large
            text
            style="width: 50%;"
            @click="_setActive(false)"
            id="delete-user-cancel"
            >Cancel</v-btn
          >
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex';
import { MobileView } from '@/mixins';

export default {
  props: ['data', 'userType'],
  mixins: [MobileView],
  methods: {
    ...mapMutations({
      _setActive: 'account/setDeleteUser',
    }),
    ...mapActions({
      _deleteUser: 'account/deleteUser',
    }),
    clickHandler() {
      const payload = {
        id: this.data.uuid,
        type: this.data.type_name,
        userType: this.userType,
      };
      this._deleteUser(payload);
      this._setActive(false);
    },
  },
  computed: {
    ...mapGetters({
      getDeleteUser: 'account/getDeleteUser',
    }),
    dialogStyle() {
      if (this.showMobileView) {
        return '';
      }
      return '50%';
    },
  },
};
</script>

<style></style>
